import { useMutation, useQueryClient } from '@tanstack/react-query';

import { setDebitCardSpendingLimits } from '@/react-query/services/spending-limits';

import { DebitSpendingLimit } from '@generated-types';

interface SetDebitCardSpendingLimitsRequest {
    cardId: string;
    limit: DebitSpendingLimit;
}

export const useSetDebitCardSpendingLimits = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['setDebitCardSpendingLimits'],
        mutationFn: ({ cardId, limit }: SetDebitCardSpendingLimitsRequest) => setDebitCardSpendingLimits(cardId, limit),
        onSettled: (data, error, { cardId }) => {
            queryClient.invalidateQueries({ queryKey: ['debitCardSpendingLimits', cardId] });
        },
    });
};
